import styled from 'styled-components';
import { reactSelectStyles } from 'utils/style';

export const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledJourneyId = styled.span`
  color: var(--grey900);
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
`;

export const StyledShipperOrderId = styled.span`
  color: var(--grey700);
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
`;

export const StyledNotFound = styled.span`
  color: var(--error900);
`;

export const orderSearchStyles = {
  ...reactSelectStyles,
  container: (base) => ({
    ...base,
    width: '136px',
  }),
  control: (base) => ({
    ...base,
    borderColor: '#9B9B9B',
    borderRadius: '0px',
    minHeight: 32,
    '&:focus': {
      boxShadow: '0px 0px 15px 2px rgba(103,151,254,0.86);',
      border: '2px solid #6797fe',
    },
  }),
};
